"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarButtonBase = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _web = require("@react-hookz/web");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _tooltip = require("../../tooltip");
var _ToolbarPropsContext = require("../context/ToolbarPropsContext");
var _ToolbarSizeContext = require("../context/ToolbarSizeContext");
var _ToolbarButtonIcon = require("../styled/ToolbarButtonIcon");
var _ToolbarButtonStyled = require("../styled/ToolbarButtonStyled");
var _ToolbarButtonText = require("../styled/ToolbarButtonText");
var _ToolbarMenuButtonArrow = require("../styled/ToolbarMenuButtonArrow");
var _ToolbarSplitButtonArrow = require("../styled/ToolbarSplitButtonArrow");
var _toolbarTheme = require("../styled/toolbarTheme");
const ToolbarButtonBase = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    iconBefore,
    iconAfter,
    isChecked = false,
    isDisabled = false,
    isHovered = false,
    isOpen = false,
    text,
    toolbarButtonType,
    width,
    maxWidth,
    textAlign,
    label,
    tooltipText,
    tooltipPlacement = "top",
    tooltipVisualOnly,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const getIconAfter = (0, _react.useMemo)(() => {
    let icon;
    if (toolbarButtonType === "ToolbarMenuButton") {
      icon = iconAfter && /*#__PURE__*/_react.default.createElement(_ToolbarMenuButtonArrow.ToolbarMenuButtonArrow, null, iconAfter);
    } else if (toolbarButtonType === "ToolbarRightSplitButton") {
      icon = iconAfter && /*#__PURE__*/_react.default.createElement(_ToolbarSplitButtonArrow.ToolbarSplitButtonArrow, null, iconAfter);
    } else {
      icon = iconAfter && /*#__PURE__*/_react.default.createElement(_ToolbarButtonIcon.ToolbarButtonIcon, null, iconAfter);
    }
    return icon;
  }, [iconAfter, toolbarButtonType]);
  const {
    toolbarSize
  } = (0, _react.useContext)(_ToolbarSizeContext.ToolbarSizeContext);
  const {
    tooltipProps,
    targetProps
  } = (0, _tooltip.useTooltip)({
    placement: tooltipPlacement,
    targetRef: ref,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onBlur: onBlur,
    offset: {
      distance: 12
    },
    visualOnly: tooltipVisualOnly
  });
  const {
    renderOn
  } = (0, _ToolbarPropsContext.useToolbarPropsContext)();

  // if the user just opened the menu, prevent any outstanding tooltip delayed opens from firing
  //  just in case the user suddenly moves the mouse somewhere else (we don't want the tooltip coming back
  //  here later if we don't still have hover/focus).
  const prevIsOpen = (0, _web.usePrevious)(isOpen);
  (0, _react.useEffect)(() => {
    if (!prevIsOpen && isOpen) tooltipProps?.cancelEnterTimer?.();
  }, [tooltipProps, isOpen, prevIsOpen]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ToolbarButtonStyled.ToolbarButtonStyled, (0, _extends2.default)({}, rest, targetProps, {
    "aria-label": label,
    toolbarSize: toolbarSize,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isHovered: isHovered,
    isOpen: isOpen,
    themeMode: themeMode,
    renderOn: renderOn
    // We will re-apply our own styling w/ createFocusRingStyles.
    ,
    omitFocusRing: true,
    iconOnly: !text && (
    //no text
    !!iconBefore || !!iconAfter) &&
    //one or the other
    !(!!iconBefore && !!iconAfter) //not both
    ,

    style: {
      ...rest.style,
      width: width ? `${width}px` : "",
      maxWidth: maxWidth ? `${maxWidth}px` : ""
    }
  }), iconBefore && /*#__PURE__*/_react.default.createElement(_ToolbarButtonIcon.ToolbarButtonIcon, null, iconBefore), text && /*#__PURE__*/_react.default.createElement(_ToolbarButtonText.ToolbarButtonText, {
    toolbarSize: toolbarSize,
    hasIconAfter: iconAfter !== undefined,
    hasIconBefore: iconBefore !== undefined,
    lineClamp: 1,
    textAlign: textAlign,
    toolbarButtonType: toolbarButtonType,
    omitTooltip: true
    // @ts-expect-error variant type is complaining
    ,
    variant: _toolbarTheme.toolbarFontTheme.variant(themeMode)
  }, text), getIconAfter), tooltipText && /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, tooltipProps, /*#__PURE__*/_react.default.createElement(_tooltip.TooltipBody, null, tooltipText)));
});
exports.ToolbarButtonBase = ToolbarButtonBase;
ToolbarButtonBase.displayName = "ToolbarButtonBase";
//# sourceMappingURL=ToolbarButtonBase.js.map